/*
* @Author: tengmaoqing
* @Date:   2018-06-14 09:44:50
* @Last Modified by:   tengmaoqing
* @Last Modified time: 2018-07-02 16:22:01
*/

module.exports = {
  'title': '手机回收',
  'slogan': '手机回收',
  'orderList': '订单列表',
  'recycleList': '回收列表',
  'exit': '退出',
  'loading': '加载中',
  'withoutMore': '没有更多数据了',
  'showMore': '查看更多',
  'orderNum': '订单号',
  'cancelOrder': '取消订单',
  'cancel': '取消',
  'confirm': '确认',
  'tip': '提示',
  'warn': '警告',
  'close': '关闭',
  'back': '返回',
  'inquery': '查询',
  'beginRecycle': '开始回收',
  'withoutRelativeData': '没有找到相关数据',
  'home': '首页',
  'searchWhatYouWantEvalProduct': '搜索您要估价的机型',
  'placeorderTime': '下单时间',
  'noData': '暂无',
  'ensure': '确定',
  'havePlaceOrdered': '已下单',
  account: {
    editPWD: '修改密码',
    oldPWD: '旧密码',
    newPWD: '新密码',
    oldPWDPlaceholder: '请输入旧密码',
    newPWDPlaceholder: '请输入新密码',
    confirm: '请再次输入新密码',
    submit: '确认',
    tip: '6-12位字符，只允许输入字母或数字（字母区分大小写）',
    tip2: '两次输入的密码必须相同'
  },

  'login': {
    account: '账号',
    pwd: '密码',
    remember: '记住账号',
    login: '登录',
    loginTip: '如果没有账号请联系管理员开通',
    send: '发送',
    tel: '输入手机号',
    code: '短信验证码',
    tips: '若未注册回收宝账号，将自动注册回收宝账号',
    getcode: '获取验证码',
    limitCodeFail: '验证失败，请重新验证',
    autoLogin: '15天内免登录',
    success: '发送成功!'
  },

  'evaluate': {
    'selected': '已选',
    'edit': '修改',
    'unselected': '请先选择上一项',
    'function': '功能选项(非必选)',
    'submit': '立即估价',
    'reChooseProduct': '重选机型'
  },

  'evluateRes': {
    'imie': '拨号页面输入*#06# 可查看IMEI',
    'cancel': '取消交易',
    'confirm': '确认回收',
    'evaluateTip': '初步评估报价',
    'reEvaluate': '重新估价',
    'upload': '上传图片',
    'uploadTip': '最多上传 6 张图片',
    evaluatePrice: '系统估价'
  },

  'order': {
    'search': '请输入订单号查询',
    noOrders: '还没有回收订单',
    noOrdersTip: '选【马上回收】，手机立刻变现',
    noOrderAction: '马上回收',
    myOrder: '我的回收单'
  },

  'orderRes': {
    'orderTip': '请将订单号粘贴在手机背面',
    'continue': '继续回收',
    'orderInfo': '订单信息'
  },

  initOrder: {
    checklist: '结算清单',
    productName: '型号',
    evaluate: '系统估价',
    total: '小计（元）',
    recycleType: '回收方式',
    userInfo: '个人信息',
    userName: '姓名',
    userNameErrMsg: '请输入姓名',
    userTel: '联系电话',
    userMail: '联系邮箱',
    recycleAddr: '回收地址',
    recycleAddrMsg: '请选择地址信息',
    state: '省',
    city: '市',
    addrDetail: '详细地址',
    addrDetailMsg: '请输入详细地址',
    buildNo: '楼栋',
    department: '公寓号',
    zipCode: '邮编',
    zipCodeMsg: '请输入邮编',
    collectInfo: '收款信息',
    bank: '请选择银行',
    banName: '收款姓名',
    banNameMsg: '请输入收款姓名',
    bankAccout: '银行卡号',
    bankAccoutMsg: '请输入银行卡号',
    notice: '注意事项',
    quiteAccount: '解锁',
    quiteAccountTip: '请解除开机密码并且注销手机账户，以确保您的隐私安全和顺利质检；对未解锁的手机，我们将拒签退回。',
    howToMake: '如何解锁',
    makeTip: `<p>
      ios设备（关闭iCloud和屏幕锁）：
    </p>
    <p>
      1.选择【设置】-> 点击最上方的【账号】->【iCloud】<br/>->【查找我的iPhone】->【关闭】–输入密码（部分机型没有查找我的iPhone）；
    </p>
    <p>
      2.选择【设置】-> 点击最上方的【账号】->【退出登录】<br/>-> 输入Apple ID密码，点击【关闭】
    </p>
    <p>
    3.【设置】->【Touch ID与密码】或者【面容ID与密码】<br/>->输入密码->关闭密码。
    </p>
    <br>
    <p>
      Android设备 账号注销方式：
    </p>
    <p>
    选择【设置】->找到“账号/账户” ->进入页面后，<br/>在最下方点击“退出账号/删除账号”
    </p>
    <p>
    ->确认“删除/注销”
    </p>
    <p>
    注：不同的品牌设备，账号的位置不一致，可以在设置上方的搜索框<br/>输入“账号”或“账户”找到入口，如有疑问可以联系400-661-2099为您服务。
    </p>`,
    selectedGoods: '已选商品',
    selectedUnit: '件',
    agree: '我已经阅读并同意',
    serviceName: '《以旧换新服务条款》',
    submit: '提交订单'
  },

  'orderDetail': {
    'detail': '订单详情',
    'cancelOrderConfirm': '确认取消订单？用户需退款后才能取消订单',
    'updateRemark': '修改备注',
    'fillRemark': '填写备注',
    'overtimeTip': '超过24小时订单将无法取消',
    'recycleStore': '回收门店',
    'staffId': '员工工号',
    'recyclePerson': '回收人员',
    'orderRemark': '订单备注',
    'overtimeWarn': '',
    orderNo: '订单编号',
    orderTime: '下单时间',
    evaluatePrice: '初始价格',
    detectionPrice: '检测价格',
    recycleType: '回收方式',
    recycleInfo: '回收信息',
    recycleAddr: '回收地址',
    recycleUserName: '客户姓名',
    recycleUserTel: '用户手机号',
    recycleUserMail: '邮箱',
    payInfo: '收款信息',
    payType: '收款方式',
    payBankName: '银行名称',
    payBankCode: '银行卡号',
    payBankUserName: '收款人',
    cancelOrderTip: '取消订单后，我们会将手机按照回收地址邮寄退回'
  },

  'welcome': {
    'chooseProduct': '选择机型',
    'quickEva': '快速估价',
    'getPrice': '获得报价',
    'submitOrder': '提交订单'
  },

  'search': {
    'searchWhatYouWantEvalProduct': '搜索您要估价的机型'
  },

  service: {
    tel: '回收宝客服电话',
    time: '服务时间'
  },

  'temp': {
    'email': '请输入邮箱',
    'emailsuccuss': '提交成功！'
  }
};



// WEBPACK FOOTER //
// ./src/system/locales/hsb/zh-cn.js